<template>
  <div id="app" :class="[printMode ? 'print_mode' : 'screen_mode']">
    <div id="app_bg"></div>
    <div id="app_fg">
      <div id="page_header" class="blurbar">
        <router-link :to="{ name : 'home' }"><logo :scale="0.2"></logo></router-link>
      </div>
      <div id="page_body">
        <router-view />
      </div>
      <div id="page_footer">
        <div v-if="showFooterNav" id="page_footer_nav" class="blurbar_deep">
          <div class="footer_link"
               v-for="route in footerRoutes"
               :key="route.name">
            <router-link :to="{ name : route.name }">{{ route.meta.viewName }}</router-link>
          </div>
        </div>
        <div id="page_footer_text" class="blurbar_deep">&copy; Cedric Hobbs <span v-html="copyrightYearRange"></span></div>
      </div>
    </div>
  </div>
</template>

<script>

import Logo from '@/components/layout/logo';

export default {
    name       : "App",
    components : { Logo },
    data() {
        return {
            copyrightStartYear : 2019
        };
    },
    computed : {
        footerRoutes() {
            return this.$router.options.routes.filter(
                (item) => item.meta.useInFooterNav
            );
        },
        showFooterNav() {
            return this.$route.meta.showFooterNav;
        },
        copyrightYearRange() {
            const now  = new Date();
            const year = now.getFullYear();

            if (year === this.copyrightStartYear) {
                return year;
            }

            return `${this.copyrightStartYear} &ndash; ${year}`;
        },
        printMode() {
            return this.$route.query.format === 'print';
        }
    }
};

</script>

<style scoped>

#app.screen_mode {
    text-align:left;
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    background-image:-webkit-linear-gradient(to bottom, var(--main-gray) var(--page-header-height), var(--core-black));
    background-image:-moz-linear-gradient(to bottom, var(--main-gray) var(--page-header-height), var(--core-black));
    background-image:-ms-linear-gradient(to bottom, var(--main-gray) var(--page-header-height), var(--core-black));
    background-image:linear-gradient(to bottom, var(--main-gray) var(--page-header-height), var(--core-black));

}

#app.screen_mode #app_bg {
    position:absolute;
    top:var(--page-header-height);
    left:0px;
    width:100%;
    height:calc(100% - var(--page-header-height));
    background-image:url('/images/main-bg.png');
    background-size:cover;
    background-repeat:no-repeat;
    background-position:top center;
    opacity:0.1;
}

#app.screen_mode #app_fg {
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
}

#app.screen_mode #page_header {
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:var(--page-header-height);
    display:flex;
    justify-content:center;
    align-items:center;
}

#app.screen_mode #page_body {
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:calc(100% - var(--page-header-height) - var(--page-footer-height) - var(--page-footer-offset));
    max-height:calc(100% - var(--page-header-height) - var(--page-footer-height) - var(--page-footer-offset));
    padding-top:var(--page-header-height);
    padding-bottom:calc(var(--page-footer-height) + var(--page-footer-offset));
    overflow:auto;
}

#app.screen_mode #page_footer {
    position:absolute;
    bottom:var(--page-footer-offset);
    left:0px;
    width:100%;
    height:var(--page-footer-height);
    display:flex;
    flex-direction:column;
    justify-content:flex-end;
}

#app.screen_mode #page_header,
#app.screen_mode #page_footer {
    z-index:2;
}
#app.screen_mode #page_body {
    z-index:1;
}

#app.screen_mode #page_footer > #page_footer_text {
    text-align:center;
    font-size:16px;
    height:36px;
    line-height:36px;
    letter-spacing:0.2em;
}

#app.screen_mode #page_footer > #page_footer_nav {
    height:36px;
    margin-bottom:8px;
    display:flex;
    flex-wrap:nowrap;
    justify-content:center;
    align-items:center;
}

#app.screen_mode #page_footer > #page_footer_nav > .footer_link {
    font-size:18px;
    padding:0px 20px;
}

#app.screen_mode #page_footer > #page_footer_nav > .footer_link a {
    text-decoration:none;
}

#app.print_mode {

}

#app.print_mode #app_bg {
    display:none;
}

#app.print_mode #page_header {
    text-align:center;
    padding:20px 0px;
    position:relative;
    background-image:-webkit-linear-gradient(to bottom, var(--main-gray), var(--core-black));
    background-image:-moz-linear-gradient(to bottom, var(--main-gray), var(--core-black));
    background-image:-ms-linear-gradient(to bottom, var(--main-gray), var(--core-black));
    background-image:linear-gradient(to bottom, var(--main-gray), var(--core-black));
}

#app.print_mode #page_header:before {
    content:"";
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    background-image:url('/images/main-bg.png');
    background-size:cover;
    background-repeat:no-repeat;
    background-position:center;
    opacity:0.1;
}

#app .blurbar {
    background-color:rgba(var(--main-gray-rgb), 0.95);
}

#app .blurbar_deep {
    background-color:rgba(var(--dark-gray-rgb), 0.9);
}

@supports(backdrop-filter:blur(20px)) {
    #app .blurbar {
        background-color:rgba(var(--main-gray-rgb), 0.8);
        backdrop-filter:blur(20px);
    }

    #app .blurbar_deep {
        background-color:rgba(var(--main-gray-rgb), 0.25);
        backdrop-filter:blur(20px);
    }
}

@media screen and (max-width:500px) {
    #app.screen_mode #page_footer > #page_footer_nav > .footer_link {
        font-size:16px;
    }
}

</style>

<style>

.page_view {
    width:60%;
    margin:0px auto;
    padding-top:var(--page-view-top-offset)px;
}

.page_title {
    text-align:center;
    font-size:32px;
    padding:15px 0px;
    margin-bottom:30px;
    position:relative;
}

.page_title:before {
    content:"";
    position:absolute;
    left:0px;
    bottom:0px;
    width:100%;
    height:1px;
    background-image:-webkit-linear-gradient(to right, rgba(var(--main-orange-rgb), 0), rgba(var(--main-orange-rgb), 1), rgba(var(--main-orange-rgb), 0));
    background-image:-moz-linear-gradient(to right, rgba(var(--main-orange-rgb), 0), rgba(var(--main-orange-rgb), 1), rgba(var(--main-orange-rgb), 0));
    background-image:-ms-linear-gradient(to right, rgba(var(--main-orange-rgb), 0), rgba(var(--main-orange-rgb), 1), rgba(var(--main-orange-rgb), 0));
    background-image:linear-gradient(to right, rgba(var(--main-orange-rgb), 0), rgba(var(--main-orange-rgb), 1), rgba(var(--main-orange-rgb), 0));
}

.page_content {
    text-align:left;
    font-size:24px;
    padding:40px;
}

.panel {
    margin-bottom:40px;
}

.panel_header,
.panel_footer {
    background-color:rgba(var(--core-black-rgb), 0.15);
    font-size:24px;
    padding:5px 10px;
}

.panel_title {
    font-size:24px;
    display:flex;
    justify-content:space-between;
    align-items:flex-end;
}

.panel_body {
    padding:10px;
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
}

.panel_body + .panel_body {
    margin-top:40px;
}

.panel_footer {
    font-size:18px;
    text-align:center;
}

@media only screen and (max-width:500px) {
    .page_view {
        width:80%;
    }

    .page_title {
        font-size:24px;
        padding:10px 0px;
        margin-bottom:20px;
    }

    .page_content {
        font-size:18px;
        padding:20px;
    }

    .panel_title {
        font-size:20px;
        flex-direction:column;
        justify-content:flex-start;
        align-items:center;
    }

    .panel_title {
        font-size:22px;
    }

    .panel_body {
        flex-direction:column;
    }

    .panel_footer {
        font-size:16px;
    }
}

@media print {
    .print_mode #page_header,
    .print_mode #page_footer {
        display:none
    }

    .print_mode #page_body {
        width:100%;
        height:100%;
        min-height:100%;
        max-height:none;
        padding-top:0px;
        padding-bottom:0px;
    }

    @page {
        size:A4;
        margin:1in;
    }
}

</style>
